import { createSelector } from 'reselect'

import { initialState, ProfileReducer } from '../reducers/domain'

const getProfile = (state: { profile: ProfileReducer }) => (state.profile && state.profile.data) || initialState.data

export default createSelector(getProfile, (profile) => {
  const budget = typeof profile.budget === 'string' ? parseInt(profile.budget, 10) : profile.budget

  return {
    budget,
    partExchange: !!profile.partExchange,
    finance: !!profile.finance,
  }
})
